// @flow
import React, { Component } from "react";
import classNames from "classnames";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Input from "elevate-ui/Input";
import Textarea from "elevate-ui/Textarea";
import Button from "elevate-ui/Button";
import withStyles from "elevate-ui/withStyles";
import Captcha from "../common/Captcha";
import { withGlobalContext } from "../common/GlobalContext";
import { withListingContext } from "./ListingContext";
import type { CompliantListingType } from "flow/types";
import PhoneInput from "../common/PhoneInput";

type $Props = {
  classes: Object,
  className: string,
  listing: CompliantListingType,
  assertCaptcha: Function,
  assertCaptchaV2: Function,
  isPageForceV2Captcha: Function,
  siteUser: Object,
  previousFormFieldValues: Object,
};

type $State = {
  token: string,
};

class ContactForm extends Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);
    this.state = {
      token: "",
    };
  }

  listTracLogEventLead = ({ mlsListingId, zipCode }) => {
    if (window._LT) {
      window._LT._trackEvent(window._eventType.lead, mlsListingId, zipCode);
    }
  };

  componentDidMount = () => {
    const { assertCaptchaV2, isPageForceV2Captcha } = this.props;
    if (isPageForceV2Captcha()) {
      assertCaptchaV2();
    }
  };

  onSubmit = () => {
    const { assertCaptcha, isPageForceV2Captcha, listing } = this.props;
    this.listTracLogEventLead(listing);
    if (isPageForceV2Captcha()) {
      // $FlowIgnore
      document.getElementById("contact-form").submit();
    } else {
      assertCaptcha("detail_contact").then((token) => {
        this.setState({ token }, () => {
          // $FlowIgnore
          document.getElementById("contact-form").submit();
        });
      });
    }
  };

  render() {
    const {
      classes,
      className,
      listing,
      siteUser,
      previousFormFieldValues,
      isPageForceV2Captcha,
    } = this.props;

    return (
      <div className={classNames(classes.root, className)}>
        <Formik
          initialValues={{
            firstName:
              (siteUser && siteUser.firstName) ||
              (previousFormFieldValues && previousFormFieldValues.firstName) ||
              "",
            lastName:
              (siteUser && siteUser.lastName) ||
              (previousFormFieldValues && previousFormFieldValues.lastName) ||
              "",
            email:
              (siteUser && siteUser.email) ||
              (previousFormFieldValues && previousFormFieldValues.email) ||
              "",
            comments:
              (previousFormFieldValues && previousFormFieldValues.comments) ||
              `I'd like to learn more about ${
                listing.address ? listing.address : ""
              } ${listing.cityStateZip ? listing.cityStateZip : ""}.`,
            phone:
              (siteUser && siteUser.phone) ||
              (previousFormFieldValues && previousFormFieldValues.phone) ||
              "",
          }}
          validationSchema={() =>
            Yup.object().shape({
              firstName: Yup.string().required("First name is required"),
              lastName: Yup.string().required("Last name is required"),
              email: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
              phone: Yup.string().matches(
                /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
                "Please enter valid phone number"
              ),
              comments: Yup.string(),
            })
          }
          onSubmit={this.onSubmit}
          render={({ isSubmitting }) => (
            <Form
              id="contact-form"
              method="POST"
              className={classes.form}
              noValidate
            >
              <Field
                id="firstName"
                name="firstName"
                label="First Name"
                component={Input}
                type={siteUser && siteUser.firstName ? "hidden" : "text"}
              />
              <Field
                id="lastName"
                name="lastName"
                label="Last Name"
                component={Input}
                type={siteUser && siteUser.lastName ? "hidden" : "text"}
              />
              <Field
                id="email"
                name="email"
                label="Email"
                placeholder="your@email.com"
                component={Input}
                type={siteUser && siteUser.email ? "hidden" : "text"}
              />
              <Field
                id="phone"
                name="phone"
                label="Phone"
                component={PhoneInput}
                type={siteUser && siteUser.phone ? "hidden" : "tel"}
              />
              <Field
                id="comments"
                name="comments"
                label="Comments / Questions"
                type="comments"
                component={Textarea}
              />
              <Captcha
                token={this.state.token}
                isPageForceV2Captcha={isPageForceV2Captcha()}
              />
              <Button
                type="submit"
                className={classes.contactDetailButton}
                disabled={isSubmitting}
              >
                Send Message
              </Button>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default withStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  contactDetailButton: {
    width: "100%",
    fontSize: "14px",
  },
}))(withGlobalContext(withListingContext(ContactForm)));
